export const VITE_API_PROXY_BASE_URL = import.meta.env.VITE_API_PROXY_BASE_URL
export const VITE_WEBSITE_PUBLISHER_API_BASE_URL = import.meta.env
  .VITE_WEBSITE_PUBLISHER_API_BASE_URL
